(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[826],{

/***/ 2843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ app),
/* harmony export */   setGlobalConfig: () => (/* binding */ setGlobalConfig)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4635);



function app() {
  setGlobalConfig()
  prefixClasses()
  setHeaderVars()
  initFileRouter()
}

// Creates a global config object with useful element selectors, theme data, etc.
function setGlobalConfig() {
  window.config = window.config || {}

  // Leave empty if not using a tailwind prefix
  window.config.twPrefix = ''

  // Toggle to view custom error/warning messages
  window.config.debugMode = true

  window.config.$ = (jquery__WEBPACK_IMPORTED_MODULE_0___default())

  window.config.screens = {
    'sm': 640,
    // => @media (min-width: 640px) { ... }
    'md': 768,
    // => @media (min-width: 768px) { ... }
    'lg': 1024,
    // => @media (min-width: 1024px) { ... }
    'xl': 1280,
    // => @media (min-width: 1280px) { ... }
    '2xl': 1536,
  }
}

function setHeaderVars() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load resize', function () {
    if ((0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-header')])) {
      window.config.navHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-header').outerHeight()
      document.body.style.setProperty('--nav-height', `${window.config.navHeight}px`)
    }

    if ((0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-announcement-bar')])) {
      window.config.barHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.section-announcement-bar').outerHeight()
      document.body.style.setProperty('--bar-height', `${window.config.barHeight}px`)
    }
  })
}

// Add classes that you want to reference within other JS files
function prefixClasses() {
  window.config.classes = {
    active: config.twPrefix + 'on',
    loading: config.twPrefix + 'loading',
    loaded: config.twPrefix + 'loaded',
    error: config.twPrefix + 'error',
    unavailable: config.twPrefix + 'oos',
    animationActive: config.twPrefix + 'revealing',
    animationComplete: config.twPrefix + 'revealed',
    hidden: config.twPrefix + 'hidden',
    activeChild: config.twPrefix + 'child-on',
    colSpanFull: config.twPrefix + 'col-span-full',
  }
}

function initFileRouter() {
  const watchForSelectors = [
    { path: 'utilities', selector: '[data-utility]' },
    { path: 'components', selector: '[data-component]' },
    { path: 'utilities', selector: '[class*="reveal"]', fileName: 'reveal' },
  ]

  watchForSelectors.forEach(watchForFile)
}

// Watches for and provided selector, then imports the related file
function watchForFile({ selector, path, fileName }) {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(selector, ($elements) => {
    if (!$elements.length) return

    $elements.each(function () {
      const targetElement = this
      const attribute = selector.replace('[', '').replace(']', '')
      const fileHandle = fileName || jquery__WEBPACK_IMPORTED_MODULE_0___default()(targetElement).attr(attribute)
      const splitHandles = fileHandle.split(',')

      splitHandles.forEach(function (handle) {
        importFile({ path, fileName: handle, element: targetElement })
      })
    })
  })
}

// Imports a file based on the provided path and file name
function importFile({ path, fileName, element }) {
  __webpack_require__(7526)(`./${path}/${fileName}`)
    .then(({ default: defaultFunction }) => {
      defaultFunction({ wrapper: element })
    })
    .catch((error) => {
      // Only fires the warning if 'debugMode' is on
      if (window.config.debugMode) {
        console.warn(`Failed to import "${path}/${fileName}.js"`, { error })
      }
    })
}


/***/ }),

/***/ 7526:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./app/": [
		2843
	],
	"./app/index": [
		2843
	],
	"./app/index.js": [
		2843
	],
	"./components/accent-image": [
		4826,
		4826
	],
	"./components/accent-image.js": [
		4826,
		4826
	],
	"./components/accordion": [
		3171,
		3171
	],
	"./components/accordion.js": [
		3171,
		3171
	],
	"./components/account-popup": [
		5493,
		5493
	],
	"./components/account-popup.js": [
		5493,
		5493
	],
	"./components/addresses": [
		4151,
		4151
	],
	"./components/addresses.js": [
		4151,
		4151
	],
	"./components/afterpay-widget": [
		7839,
		7839
	],
	"./components/afterpay-widget.js": [
		7839,
		7839
	],
	"./components/cart-notification": [
		1020,
		1020
	],
	"./components/cart-notification.js": [
		1020,
		1020
	],
	"./components/collection/grid": [
		4663,
		4663
	],
	"./components/collection/grid.js": [
		4663,
		4663
	],
	"./components/compare-toggle": [
		1329,
		1329
	],
	"./components/compare-toggle.js": [
		1329,
		1329
	],
	"./components/how-to-home": [
		8088,
		8088
	],
	"./components/how-to-home.js": [
		8088,
		8088
	],
	"./components/marquee": [
		9216,
		9216
	],
	"./components/marquee.js": [
		9216,
		9216
	],
	"./components/menu": [
		542,
		542
	],
	"./components/menu/": [
		542,
		542
	],
	"./components/menu/headerScroll": [
		7713,
		7713
	],
	"./components/menu/headerScroll.js": [
		7713,
		7713
	],
	"./components/menu/index": [
		542,
		542
	],
	"./components/menu/index.js": [
		542,
		542
	],
	"./components/menu/megaMenu": [
		1592,
		1592
	],
	"./components/menu/megaMenu.js": [
		1592,
		1592
	],
	"./components/modal": [
		8228,
		8228
	],
	"./components/modal.js": [
		8228,
		8228
	],
	"./components/overlay": [
		818,
		818
	],
	"./components/overlay.js": [
		818,
		818
	],
	"./components/parallax": [
		4074,
		4074
	],
	"./components/parallax.js": [
		4074,
		4074
	],
	"./components/product-quiz": [
		2167,
		2167
	],
	"./components/product-quiz.js": [
		2167,
		2167
	],
	"./components/product-upgrade": [
		1089,
		1089
	],
	"./components/product-upgrade.js": [
		1089,
		1089
	],
	"./components/product/add-on": [
		6586,
		6586
	],
	"./components/product/add-on.js": [
		6586,
		6586
	],
	"./components/product/form": [
		5940,
		7475,
		5940
	],
	"./components/product/form.js": [
		5940,
		7475,
		5940
	],
	"./components/product/multi-select": [
		8074,
		8074
	],
	"./components/product/multi-select.js": [
		8074,
		8074
	],
	"./components/product/recommendations": [
		8168,
		8168
	],
	"./components/product/recommendations.js": [
		8168,
		8168
	],
	"./components/product/reviews": [
		5854,
		5854
	],
	"./components/product/reviews.js": [
		5854,
		5854
	],
	"./components/promotional-sale": [
		6310,
		6310
	],
	"./components/promotional-sale.js": [
		6310,
		6310
	],
	"./components/quiz-block": [
		1872,
		1872
	],
	"./components/quiz-block.js": [
		1872,
		1872
	],
	"./components/section-render": [
		1919,
		1919
	],
	"./components/section-render.js": [
		1919,
		1919
	],
	"./components/select-action": [
		5961,
		5961
	],
	"./components/select-action.js": [
		5961,
		5961
	],
	"./components/slick-slider": [
		4165,
		7475,
		4165
	],
	"./components/slick-slider.js": [
		4165,
		7475,
		4165
	],
	"./components/slide-cart": [
		8956,
		8956
	],
	"./components/slide-cart.js": [
		8956,
		8956
	],
	"./components/slide-toggle": [
		6507,
		6507
	],
	"./components/slide-toggle.js": [
		6507,
		6507
	],
	"./components/sticky-nav": [
		2934,
		2934
	],
	"./components/sticky-nav.js": [
		2934,
		2934
	],
	"./components/video-player": [
		2538,
		2538
	],
	"./components/video-player.js": [
		2538,
		2538
	],
	"./components/vimeo-player": [
		2371,
		8333,
		2371
	],
	"./components/vimeo-player.js": [
		2371,
		8333,
		2371
	],
	"./components/yotpo": [
		4664,
		4664
	],
	"./components/yotpo.js": [
		4664,
		4664
	],
	"./components/z-over-nav": [
		1842,
		1842
	],
	"./components/z-over-nav.js": [
		1842,
		1842
	],
	"./utilities/click-toggle": [
		9667,
		9667
	],
	"./utilities/click-toggle.js": [
		9667,
		9667
	],
	"./utilities/custom-select": [
		7231,
		7231
	],
	"./utilities/custom-select.js": [
		7231,
		7231
	],
	"./utilities/event-trigger": [
		7413,
		7413
	],
	"./utilities/event-trigger.js": [
		7413,
		7413
	],
	"./utilities/functions": [
		6466,
		6466
	],
	"./utilities/functions.js": [
		6466,
		6466
	],
	"./utilities/gsap-scroll": [
		9880,
		7900,
		9880
	],
	"./utilities/gsap-scroll.js": [
		9880,
		7900,
		9880
	],
	"./utilities/hover-toggle": [
		3880,
		3880
	],
	"./utilities/hover-toggle.js": [
		3880,
		3880
	],
	"./utilities/inline-toggle": [
		5657,
		5657
	],
	"./utilities/inline-toggle.js": [
		5657,
		5657
	],
	"./utilities/link-to": [
		1531,
		1531
	],
	"./utilities/link-to.js": [
		1531,
		1531
	],
	"./utilities/plugins": [
		2865
	],
	"./utilities/plugins.js": [
		2865
	],
	"./utilities/return-focus": [
		5276,
		5276
	],
	"./utilities/return-focus.js": [
		5276,
		5276
	],
	"./utilities/reveal": [
		1021,
		1021
	],
	"./utilities/reveal.js": [
		1021,
		1021
	],
	"./utilities/scroll-toggle": [
		1549,
		1549
	],
	"./utilities/scroll-toggle.js": [
		1549,
		1549
	],
	"./utilities/scroll-trigger": [
		9176,
		9176
	],
	"./utilities/scroll-trigger.js": [
		9176,
		9176
	],
	"./utilities/section-nav": [
		982,
		982
	],
	"./utilities/section-nav.js": [
		982,
		982
	],
	"./utilities/tab-list": [
		2097,
		2097
	],
	"./utilities/tab-list.js": [
		2097,
		2097
	],
	"./utilities/trap-focus": [
		5008,
		5008
	],
	"./utilities/trap-focus.js": [
		5008,
		5008
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7526;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 4635:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ elementsExist)
/* harmony export */ });
/**
 * * Checks if the given elements exist on the DOM
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */

function elementsExist(elements = []) {
  return elements.filter((el) => el.length).length == elements.length
}

/***/ })

}]);